/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schulwechselmotivation1Inputs */



/**

* @param {_Field_Schulwechselmotivation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schulwechselmotivation1 = /** @type {((inputs?: _Field_Schulwechselmotivation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schulwechselmotivation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Schulwechsel Grund")
});
export { _field_schulwechselmotivation1 as "_field_schulwechselMotivation" }